<template>
    <div>
        <div class="mcc-page-header">

            <div class="mu-d-flex">
                <h1>{{ title }}</h1>
                <details class="mcc-popover mcc-popover--bottom-end">

                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
 
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

            </div>
        </div>
        <div class="mcc-container mu-m-06">

            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>My tasks</li>
                    <li>{{ title }}</li>
                    <li class="lastBredCrumpLi">

                    </li>
                </ol>
            </nav>

            <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="submitDialog" title="Task Filters">
               

                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <form id="formIdd">
                                    <div>
                                        <div class="mfc-input-wrapper mfc-form-input-container drawer-input">
                                            <label for="name">Task name</label>
                                            <input type="text" name="task-name" maxlength="100" id="name"
                                                :pattern="nameRegex" :value="taskNameRef"
                                                @change="taskNameRef = $event.target.value">

                                        </div>
                                       <div class="mfc-input-wrapper mfc-form-input-container drawer-input">
                                            <label for="name">Task Id</label>
                                            <input type="text" name="task-id" maxlength="100" id="taskId"
                                                 :value="taskIdRef"
                                                @change="taskIdRef = $event.target.value">
                                        </div>
                                        <div class="mcc-segmented-buttons mcc-segmented-buttons--sm drawer-input"
                                            v-if="!unclaimedTasks">
                                            <fieldset class="mfc-fieldset">
                                                <legend class="mfc-label">
                                                    Status
                                                </legend>
                                                <div class="mcc-segmented-buttons__list" label="Status" block
                                                    ref="radioRef" name="status-radioGroup" id="status-radioGroup">
                                                    <input type="checkbox" name="not-started" value="open"
                                                        id="not-started" @click="statusRef = $event.target.value"
                                                        :checked="statusRef == 'open'">
                                                    <label class="mcc-segmented-buttons__button" for="not-started">
                                                        <span class="mcc-segmented-buttons__label">open</span>
                                                    </label>
                                                    <input type="checkbox" name="pending" value="completed" id="pending"
                                                        @click="statusRef = $event.target.value"
                                                        :checked="statusRef == 'completed'">
                                                    <label class="mcc-segmented-buttons__button" for="pending">
                                                        <span class="mcc-segmented-buttons__label">Completed</span>
                                                    </label>
                                                    <input type="checkbox" name="in-progress" value="all"
                                                        id="in-progress" @click="statusRef = $event.target.value"
                                                        :checked="statusRef == 'all'">
                                                    <label class="mcc-segmented-buttons__button" for="in-progress">
                                                        <span class="mcc-segmented-buttons__label">All</span>
                                                    </label>
                                                </div>
                                            </fieldset>
                                        </div>


                                        <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm drawer-input">
                                            <fieldset class="mfc-fieldset">
                                                <legend class="mfc-label">
                                                    Priority
                                                </legend>
                                                <div class="mcc-segmented-buttons__list" block ref="priorityRef"
                                                    name="priority-radioGroup" id="priority-radioGroup">
                                                    <input type="checkbox" name="Low" value="0" id="Low"
                                                        @click="priorityRef = $event.target.value"
                                                        :checked="priorityRef == '0'">
                                                    <label class="mcc-segmented-buttons__button" for="Low">
                                                        <span class="mcc-segmented-buttons__label">Low</span>
                                                    </label>
                                                    <input type="checkbox" name="Normal" value="50" id="Normal"
                                                        @click="priorityRef = $event.target.value"
                                                        :checked="priorityRef == '50'">
                                                    <label class="mcc-segmented-buttons__button" for="Normal">
                                                        <span class="mcc-segmented-buttons__label">Normal</span>
                                                    </label>
                                                    <input type="checkbox" name="High" value="100" id="High"
                                                        @click="priorityRef = $event.target.value"
                                                        :checked="priorityRef == '100'">
                                                    <label class="mcc-segmented-buttons__button" for="High">
                                                        <span class="mcc-segmented-buttons__label">High</span>
                                                    </label>
                                                    <input type="checkbox" name="All" value=" " id="All"
                                                        @click="priorityRef = $event.target.value"
                                                        :checked="priorityRef == ' '">
                                                    <label class="mcc-segmented-buttons__button" for="All">
                                                        <span class="mcc-segmented-buttons__label">All</span>
                                                    </label>

                                                </div>
                                            </fieldset>
                                        </div>


                                        <div class="mfc-slim-select-wrapper drawer-input" v-show="involvingAll">
                                            <label for="selectPage"
                                                class="mu-mb-00">Assignee</label>
                                            <select :data-value="selectedAssigneeRef"
                                                @change="selectedAssigneeRef = $event.target.value" ref="assigneeRef"
                                                name="Assignee-select" id="Assignee-selectId" block label="Assignee">
                                                <option data-placeholder="true" value=""></option>
                                                <option v-for="(app, key) in userList"
                                                    :selected="selectedAssigneeRef === app.username" :key="key"
                                                    :value="app.username">{{ app.firstName }}</option>
                                            </select>
                                        </div>

                                        <div class="mfc-slim-select-wrapper drawer-input">
                                            <label for="selectPage" class=" mu-mb-00">Owner</label>
                                            <select :data-value="selectedOwnerRef"
                                                @change="selectedOwnerRef = $event.target.value" ref="ownerRef"
                                                name="owner-select" id="owner-selectId" block label="Owner">
                                                <option data-placeholder="true" value></option>
                                                <option v-for="(app, key) in userList"
                                                    :selected="selectedOwnerRef === app.username" :key="key"
                                                    :value="app.username">{{ app.firstName }}</option>
                                            </select>
                                        </div>

                                        <div class="mfc-slim-select-wrapper drawer-input">
                                            <label for="selectPage" class=" mu-mb-00">Involving</label>
                                            <select :data-value="selectedInvolvingRef"
                                                @change="selectedInvolvingRef = $event.target.value" ref="involvingRef"
                                                name="Involving-select" id="Involving-selectId" block label="Involving">
                                                <option data-placeholder="true" value></option>
                                                <option v-for="(app, key) in userList"
                                                    :selected="selectedInvolvingRef === app.username" :key="key"
                                                    :value="app.username">{{ app.firstName }}</option>
                                            </select>
                                        </div>

                                        <div class="flatpickr flatpickrGap mfc-input-wrapper drawer-input ">
                                            <label for="startDateId" class=" mb-0">Created between</label>
                                            <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text flatpickr-date--width flatpickrInstance"
                                                id="dateFromId">
                                                <input name="startDate" id="startDateId" placeholder="Select Date.."
                                                    ref="startDate" icon="calendar" data-input
                                                    @change="handleStartRangeChange($event)"
                                                    @ready="handleStartRangeReady()">
                                                <button type="button" class="mcc-button mcc-button--outline"
                                                    data-toggle aria-label="date">
                                                    <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                                </button>
                                                <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                                    <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                                    <span>Please select proper dates.</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="flatpickr flatpickrGap mfc-input-wrapper drawer-input "
                                            v-if="!unclaimedTasks">
                                            <label for="endDateId" class=" mb-0">Completed between</label>
                                            <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text flatpickr-date--width flatpickrInstances"
                                                id="dateToId">
                                                <input name="endDate" id="endDateId" ref="endDate" placeholder="Select Date.."
                                                    icon="calendar" data-input
                                                    @change="handleEndRangeChange($event)"
                                                    @ready="handleEndRangeReady()">
                                                <button type="button" class="mcc-button mcc-button--outline"
                                                    data-toggle aria-label="date">
                                                    <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                                </button>
                                                <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                                    <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                                    <span>Please select proper dates.</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                                </div>
                            </div>

                       
             
            </Drawer>

            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>
            <div class="mcc-row" v-show="fetchCall">
                <div class="mcc-col">
                    <div class="mcc-card">
                        <div class="mcc-card__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mu-pb-05 mu-radius-top">
                                                <div class="mfc-input-wrapper">
                                                    <div class="mfc-input-group mfc-input-group--leading-icon">
                                                        <mcc-icon class="mfc-input-group__icon mu-mt-02" name="search"
                                                            id="list-group-icon" aria-hidden="true"></mcc-icon>
                                                        <input id="list-group-filter" name="list-group-filter"  ref="listGroupFilter"
                                                            type="text" placeholder="Type to search...">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mcc-col mcc-col-auto">
                                            <button class="mcc-button mcc-button--outline"
                                                @click="$refs.customFilter.open()">
                                                <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                                <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' +
                    filterCount + ')' : unclaimedTasks ? '(1)' : '(2)' }}</span>
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <mcc-alert role="alert" class="mcc-alert  mcc-alert--info mcc-alert--compact"
                                        v-if="showNoRecords">
                                        <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                                        <span>No tasks found</span>

                                        <button style="margin-inline-start: auto" @click="showNoRecords = false"
                                            class="mcc-button mcc-button--info mcc-button--sm mcc-button--icon-only">
                                            <mcc-icon name="close" icon-set="fluency-outline"
                                                aria-hidden="true"></mcc-icon>
                                            <span class="mcc-button__label">Button</span>
                                        </button>
                                    </mcc-alert>
                                    <ul class="mcc-list-group" v-show="showProcesses">
                                        <li v-for="(app, key) in processList" :key="key" class="mcc-list-group-li">

                                            <details class="mcc-collapse mu-w-100" @click="handleExpand(key)" 
                                                :id="'collapseTasks' + key">
                                                <summary>
                                                    <div class="mcc-menu__button">
                                                        <mcc-icon class="mcc-icon--advanced mr-1"
                                                            v-if="app.iconSet == ''" :name="app.processLogo"></mcc-icon>
                                                        <mcc-icon class="mr-1" v-if="app.iconSet != ''"
                                                            :name="app.processLogo" icon-set="fluency-color"></mcc-icon>
                                                        {{ app.defName }}
                                                    </div>
                                                    <span
                                                        class="mcc-chip mcc-chip--xs mu-mr-04 mcc-chip--info">{{ getTotalNumberOfProcesses(app) }}</span>
                                                    <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow"
                                                        aria-hidden="true"></mcc-icon>

                                                </summary>
                                                <div class="mcc-collapse-body mu-mt-03">
                                                    <mcc-data-table :ref="'myTable_' + app.defName" :id="'myTable'+key"></mcc-data-table>
                                                </div>
                                            </details>

                                        </li>
                                    </ul>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import axios from "axios";

import constantMessages from "../../messages";
import Table from "@advanced/component-mosaic-table";
import MyTaskListAPI from "../../services/MyTaskListAPI";
import Drawer from '../common/Drawer.vue';
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../formvalid.js';
export default {
    name: "MyTaskList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["mytasks.assigned"],
            nameRegex: constantMessages.PATTERNS["name"],
            showProcesses: false,
            fetchCall: false,
            processList: [],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            searchCriteria: {},
            tableObj: [],
            userList: [],
            currentPageSize: [],
            pageType: "StartedByMe",
            involvingAll: false,
            unclaimedTasks: false,
            assignedTasksList: false,
            title: "Assigned",
            statusRef: "open",
            statusType: "open",
            taskNameRef: "",
            taskName: "",
            priorityRef: " ",
            priority: " ",
            selectedInvolvingRef: "",
            selectedInvolving: "",
            selectedAssigneeRef: "",
            selectedAssignee: "",
            selectedOwnerRef: "",
            selectedOwner: "",
            startedAfter: "",
            startedBefore: "",
            finishedAfter: "",
            finishedBefore: "",
            startDateRangeRef: [],
            endDateRangeRef: [],
            updateCall: false,
            showNoRecords: false,
            updateCallTable: false,
            selectInstanceEntities: null,
            selectInstanceUserNames: null,
            selectInvolvingEntities: null,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
            flatPickerInstance1: null,
            flatPickerInstance2: null,
            // Add a flag to track fetched subprocesses
            subprocessesFetched: {},
        };
    },
    created() {
        this.pageType = this.$route.name;
        this.updatePageAppearance();
        this.selectInstanceEntities = new SlimSelect({
            select: '#Assignee-selectId',

        })
        this.selectInstanceUserNames = new SlimSelect({
            select: '#owner-selectId',

        })
        this.selectInvolvingEntities = new SlimSelect({
            select: '#Involving-selectId',

        })
        const listGroupFilter = document.querySelector('input#list-group-filter')

        listGroupFilter.addEventListener('input', (event) => {
            this.filterItems(event)
        })

    },
    mounted() {

        Utils.applyFixedHeaderConfiguration(this);

        var completedTaskFilter = localStorage.getItem(
            "completedTaskFilter"
        );
        if (completedTaskFilter != null && completedTaskFilter != "") {
            this.statusRef = "completed";
            this.statusType = "completed";
        }
        localStorage.removeItem(
            "completedTaskFilter"
        );
        if (localStorage.getItem(this.pageType) == this.pageType) {
            let storedTaskName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_taskName"
            );
            if (storedTaskName != null) {
                this.taskNameRef = storedTaskName
                this.taskName = storedTaskName
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_taskName"
            );

            if (!this.unclaimedTasks) {
                let storedStatus = localStorage.getItem(
                    "DataTables_" + window.location.pathname + "_statusType"
                );
                if (storedStatus != null) {
                    this.statusRef = storedStatus;
                    this.statusType = storedStatus;
                }
                localStorage.removeItem(
                    "DataTables_" + window.location.pathname + "_statusType"
                );
                let storedEndDate = localStorage
                    .getItem(
                        "DataTables_" + window.location.pathname + "_endDateRangeRef"
                    );
                if (storedEndDate != null && storedEndDate != "") {
                    var endDateRangStringArr =
                        storedEndDate.split(",");
                    if (endDateRangStringArr.length > 1) {
                        this.endDateRangeRef[0] = new Date(endDateRangStringArr[0]);
                        this.endDateRangeRef[1] = new Date(endDateRangStringArr[1]);
                    }
                    localStorage.removeItem(
                        "DataTables_" + window.location.pathname + "_endDateRangeRef"
                    );
                }
            }

            if (this.involvingAll) {
                let storedAssignee = localStorage.getItem(
                    "DataTables_" + window.location.pathname + "_selectedAssignee"
                );
                if (storedAssignee != null) {
                    this.selectedAssignee = storedAssignee;
                    this.selectedAssigneeRef = storedAssignee;
                }
                localStorage.removeItem(
                    "DataTables_" + window.location.pathname + "_selectedAssignee"
                );
            }
            let storedInvolving = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving"
            );
            if (storedInvolving != null) {
                this.selectedInvolving = storedInvolving;
                this.selectedInvolvingRef = storedInvolving;
                localStorage.removeItem(
                    "DataTables_" + window.location.pathname + "_selectedInvolving"
                );
            }
            let storedPriority = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_priority"
            );
            if (storedPriority != null) {
                this.priority = storedPriority;
                this.priorityRef = storedPriority;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_priority"
            );
            let storedOwner = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedOwner"
            );
            if (storedOwner != null) {
                this.selectedOwner = storedOwner;
                this.selectedOwnerRef = storedOwner;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedOwner"
            );
            let storedStartDate = localStorage
                .getItem(
                    "DataTables_" + window.location.pathname + "_startDateRangeRef"
                );
            if (storedStartDate != null && storedStartDate != "") {
                var startDateRangStringArr = storedStartDate
                    .split(",");
                if (startDateRangStringArr.length > 1) {
                    this.startDateRangeRef[0] = new Date(startDateRangStringArr[0]);
                    this.startDateRangeRef[1] = new Date(startDateRangStringArr[1]);
                }
            }
            this.updateDateRef();
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef"
            );

            localStorage.removeItem(this.pageType);
            this.filterCount = parseInt(
                localStorage.getItem("auditListFilterCount")
            );
            localStorage.removeItem("auditListFilterCount");
        }
        MyTaskListAPI.getUsers().then(result => {
            this.userList = result;
            this.fetchCall = true;
            self.showProcesses = true;
        });
        this.updateProcessData();
        this.selectInstanceEntities = new SlimSelect({
            select: '#Assignee-selectId',

        })
        this.selectInstanceUserNames = new SlimSelect({
            select: '#owner-selectId',

        })
        this.selectInvolvingEntities = new SlimSelect({
            select: '#Involving-selectId',

        })
        this.flatPickr()
        const listGroupFilter = document.querySelector('input#list-group-filter')
        listGroupFilter.addEventListener('input', (event) => {
            this.filterItems(event)
        })
    },

    methods: {
        resetSlimSelect() {
            this.selectInstanceEntities.setSelected('')
            this.selectInstanceUserNames.setSelected('')
            this.selectInvolvingEntities.setSelected('')

        },
        filterItems(event) {
            const listGroupComponent = document.querySelector('.mcc-list-group')
            window.filterTimeout && clearTimeout(window.filterTimeout)

            window.filterTimeout = setTimeout(() => {
                const filter = event.target.value.toLowerCase()
                const items = listGroupComponent.querySelectorAll('li')

                // clear previous filter and apply new
                items.forEach(item => item.classList.remove('mu-d-none'))
                items.forEach(item => {
                    if (!item.innerText.toLowerCase().includes(filter)) item.classList.add('mu-d-none')
                })
            }, 250)
        },
        removeFilterOnSubmit() {
            const listGroupComponent = document.querySelector('.mcc-list-group')
            window.filterTimeout && clearTimeout(window.filterTimeout)
            window.filterTimeout = setTimeout(() => {
                const items = listGroupComponent.querySelectorAll('li')
                // clear previous filter and apply new
                items.forEach(item => item.classList.remove('mu-d-none'))
            }, 250)
        },
        getFilterCount() {
            if (this.statusType != "")
                this.filterCount += 1
            if (this.taskName != "")
                this.filterCount += 1
            if (this.priority != "")
                this.filterCount += 1
            if (this.selectedOwner != "")
                this.filterCount += 1
            if (this.selectedInvolving != "")
                this.filterCount += 1
            if (this.startedAfter != "")
                this.filterCount += 1
            if (this.finishedAfter != "")
                this.filterCount += 1

        },

        flatPickr() {
            let self = this;

            self.flatPickerInstance1 = flatpickr('.flatpickrInstance', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                wrap:true,
                mode: 'range',
                defaultDate: [self.startDateRangeRef[0], self.startDateRangeRef[1]],
                onChange: (selectedDates, dateStr) => {
            
                    this.startDateRangeRef = dateStr ? dateStr.split(" to ") : [];
                },
            })

            self.flatPickerInstance2 = flatpickr('.flatpickrInstances', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.endDateRangeRef[0], self.endDateRangeRef[1]],

            })

        },
        updateProcessData() {
            let self = this;
            var queryString = "involvingAll=" + self.involvingAll;
            self.showProcesses = false;
            self.showNoRecords = false;

            if (self.statusType == "open") {
                queryString += "&finished=false";
            } else if (self.statusType == "completed") {
                queryString += "&finished=true";
            }
            if (self.startedAfter != "") {
                queryString +=
                    "&taskCreatedAfter=" +
                    self.startedAfter +
                    "&taskCreatedBefore=" +
                    this.startedBefore;
            }
            if (self.finishedAfter != "") {
                queryString +=
                    "&taskCompletedAfter=" +
                    self.finishedAfter +
                    "&taskCompletedBefore=" +
                    self.finishedBefore;
            }
            if (self.selectedInvolving != "") {
                queryString += "&taskInvolvedUser=" + encodeURI(self.selectedInvolving);
            }
            if (self.taskName != "") {
                queryString += "&taskName=" + self.taskName;
            }
            if (self.taskId && self.taskId.trim() !== "") {
                queryString += "&taskId=" + self.taskId;
            }
            if (self.priority.trim() != "") {
                queryString += "&taskPriority=" + self.priority;
            }
            if (self.selectedOwner != "") {
                queryString += "&taskOwner=" + encodeURI(self.selectedOwner);
            }
            if (self.selectedAssignee != "") {
                queryString += "&taskAssignee=" + encodeURI(self.selectedAssignee);
            }
            if (self.assignedTasksList) {
                queryString += "&currentUser=true";
            }
            if (self.unclaimedTasks) {
                queryString += "&candidateUser=true";
            }

            MyTaskListAPI.getMyProcesses(queryString).then(result => {
                
                this.processList = result;
                
                self.showProcesses = result.length > 0;
                
                if (result.length == 0) {
                    self.showNoRecords = true;
                } else {
                    for (let i = 0; i < self.processList.length; i++) {
                        if (self.processList[i].processLogo != null && self.processList[i].processLogo.indexOf(":") != -1) {
                            let procLogo = self.processList[i].processLogo.split(":");
                            self.$set(self.processList[i], 'processLogo', procLogo[0]);
                            self.$set(self.processList[i], 'iconSet', 
                                procLogo.length > 1 && procLogo[1] != "" ? "fluency-color" : "");
                        } else {
                            self.$set(self.processList[i], 'processLogo', "process");
                            self.$set(self.processList[i], 'iconSet', "");
                        }
                    }
                }
                
                // Force Vue to re-render after processing data
                self.$nextTick(() => {
                    self.$forceUpdate();
                });
            });
        },
        showFilterDialog() {
            this.showDialog()
            this.$refs.filterDialog.show();
        },
        submitDialog(e) {
            let form = $('#formIdd')
            this.$refs.listGroupFilter.value = ''
            this.removeFilterOnSubmit()
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.updateDateRef();
            this.filterCount = 0;
            this.getFilterCount();
            // this.$refs.filterDialog.close();
            this.statusType = this.statusRef;
            this.taskName = this.taskNameRef;
            this.taskId = this.taskIdRef;
            this.priority = this.priorityRef;
            this.selectedInvolving = this.selectedInvolvingRef;
            this.selectedAssignee = this.selectedAssigneeRef;
            this.selectedOwner = this.selectedOwnerRef;
            this.tableObj = [];
            this.updateProcessData();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        closeDialog() {
            this.$refs.filterDialog.close();
            this.updateCall = false;
        },
        resetFilter() {
            this.statusRef = "open";
            this.filterCount = 0;
            this.taskNameRef = "";
            this.taskName = "";
            this.taskIdRef = "";
            this.taskId = "";             
            this.statusType = "open";
            this.priorityRef = " ";
            this.priority = " ";
            this.selectedInvolving = "";
            this.selectedInvolvingRef = "";
            this.selectedAssigneeRef = "";
            this.selectedOwnerRef = "";
            this.selectedOwner = "";
            this.selectedAssignee = "";
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            this.startDateRangeRef = [];
            this.endDateRangeRef = [];
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.tableObj = [];
            this.resetSlimSelect()
            this.updateProcessData();
            flatpickr("#startDateId").destroy()
            flatpickr("#endDateId").destroy()
            this.flatPickr()
        },
        showDialog() {
            this.updateCall = true;
        },
        handleStartRangeChange(e) {
            this.startDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.startDateRangeRef = e.target.value;
            }
        },
        handleStartRangeReady() {
            if (this.startDateRangeRef.length > 1) {
                this.$refs.startDate.value =
                    moment(this.startDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.startDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        handleEndRangeChange(e) {
            this.endDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.endDateRangeRef = e.target.value;
            }
        },
        handleEndRangeReady() {
            if (this.endDateRangeRef.length > 1) {
                this.$refs.endDate.value =
                    moment(this.endDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.endDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        updateDateRef() {
            let self = this;
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            if (self.startDateRangeRef.length > 0) {
                var startDateFrom = self.startDateRangeRef.split(" to ")[0];
                var startDateTo = self.startDateRangeRef.split(" to ")[1];
                var d = new Date(startDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.startedAfter = d.toISOString();
                if (!startDateTo) {
                    startDateTo = startDateFrom
                }
                d = new Date(startDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.startedBefore = d.toISOString();
            }
            if (!self.unclaimedTasks && self.endDateRangeRef.length > 0) {
                var endDateFrom = self.endDateRangeRef.split(" to ")[0];
                var endDateTo = self.endDateRangeRef.split(" to ")[1];
                var d = new Date(endDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.finishedAfter = d.toISOString();
                if (!endDateTo) {
                    endDateTo = endDateFrom
                }
                d = new Date(endDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.finishedBefore = d.toISOString();
            }
        },

        updatePageAppearance() {
            this.involvingAll = false;
            this.unclaimedTasks = false;
            this.assignedTasksList = true;
            if (this.pageType == "Unclaimed") {
                this.title = "Unclaimed";
                this.helpText = constantMessages.BREADCRUMB_HELP["mytasks.unclaimed"];
                this.unclaimedTasks = true;
                this.assignedTasksList = false;
            } else if (this.pageType == "InvolvingMeTasks") {
                this.title = "All involved";
                this.helpText = constantMessages.BREADCRUMB_HELP["mytasks.involved"];
                this.involvingAll = true;
                this.assignedTasksList = false;
            }
        },
        handleExpand(key) {
            this.updateCallTable = true;
            this.initProcessesTable(key);
        },
        updateDynamicParamters(responseData, result, key) {
            let self = this;
            if (result.data != null) {
                result.data.forEach(row => {
                    if (
                        self.processList[key].selectedVariables != null &&
                        self.processList[key].selectedVariables.length > 0
                    ) {
                        var selectedVars = self.processList[key].selectedVariables;
                        for (var i = 0; i < selectedVars.length; i++) {
                            row["a" + selectedVars[i]] = "";
                        }
                    }
                    if (row.queryVariables != null) {
                        row.queryVariables.forEach(function (element) {
                            var currentVar = element.varName;
                            var varValue = "";
                            if (element.value != null) {
                                varValue = element.value;
                            } else if (element.varValue != null) {
                                varValue = element.varValue;
                            }
                            row["a" + currentVar] = varValue;
                        });
                    }
                });
                responseData.data = result.data;
            }
        },
        getTasksList(queryString, key) {
            let self = this;
            if (self.unclaimedTasks) {
                return MyTaskListAPI.getUnclaimedTasks(queryString).then(result => {
                    var responseData = {
                        totalCount: 0,
                        data: []
                    };
                    responseData.totalCount = result.page.totalElements;
                    result.data.forEach(item => {
                        item['createdDateString'] = item['createTime'] != null ? Utils.getMomentDateString(item['createTime']) : ''
                        item['dueDateObjectString'] = item['dueDate'] != null ? Utils.getMomentDateString(item['dueDate']) : ''
                    });
                    self.updateDynamicParamters(responseData, result, key);

                    self.updateCallTable = true;
                    self.tableData = responseData;
                    return responseData;
                });
            }
            return MyTaskListAPI.getProcessData(queryString, []).then(result => {
                var responseData = {
                    totalCount: 0,
                    data: []
                };
                responseData.totalCount = result.page.totalElements;
                result.data.forEach(item => {
                    item['createdDateString'] = item['createdDate'] != null ? Utils.getMomentDateString(item['createdDate']) : ''
                    item['dueDateObjectString'] = item['dueDateObject'] != null ? Utils.getMomentDateString(item['dueDateObject']) : ''
                    item['claimedDateString'] = item['claimedDate'] != null ? Utils.getMomentDateString(item['claimedDate']) : ''
                    item['completedDateString'] = item['completedDate'] != null ? Utils.getMomentDateString(item['completedDate']) : ''
                    item['durationInMillis'] = item['durationInMillis'] != null ? item['durationInMillis'] + ' ms' : '';
                    item['workTimeInMillis'] = item['workTimeInMillis'] != null ? item['workTimeInMillis'] + ' ms' : '';
                });
                self.updateDynamicParamters(responseData, result, key);
                self.updateCallTable = true;
                return responseData;
            });
        },
        getDataTableProperties(key) {
            let self = this;
            var prop = {};
            if (self.unclaimedTasks) {
                prop = {
                    id: {
                        type: "string",
                        title: "Id",
                        template: '<a class="name-link" data-id="{{id}}">{{id}}</a>',
                        sortable: true,
                        columnSearch: false
                    },
                    name: {
                        type: "string",
                        title: "Name",
                        template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyCreateTime: {
                        type: "string",
                        title: "Created",
                        template: '<div class="dateTemplate"><u>{{prettyCreateTime}}</u><div>{{createdDateString}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyDueDate: {
                        type: "string",
                        title: "Due",
                        template: '<div class="dateTemplate"><u>{{prettyDueDate}}</u><div>{{dueDateObjectString}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    taskPriority: {
                        type: "string",
                        title: "Priority",
                        sortable: true,
                        columnSearch: false
                    }
                };
            } else {
                prop = {
                    id: {
                        type: "string",
                        title: "Id",
                        template: '<a class="name-link" data-id="{{id}}">{{id}}</a>',
                        sortable: true,
                        columnSearch: false
                    },
                    name: {
                        type: "string",
                        title: "Name",
                        template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                        sortable: true,
                        columnSearch: false
                    },
                    assignee: {
                        type: "string",
                        title: "Assignee",
                        sortable: true,
                        columnSearch: false
                    },
                    owner: {
                        type: "string",
                        title: "Owner",
                        sortable: true,
                        columnSearch: false
                    },
                    prettyStartTime: {
                        type: "string",
                        title: "Created",
                        template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{createdDateString}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyDueDate: {
                        type: "string",
                        title: "Due",
                        template: '<div class="dateTemplate"><u>{{prettyDueDate}}</u><div>{{dueDateObjectString}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyClaimTime: {
                        type: "string",
                        title: "Claimed",
                        template: '<div class="dateTemplate"><u>{{prettyClaimTime}}</u><div>{{claimedDateString}}</div></div>',
                        sortable: false,
                        columnSearch: false
                    },
                    prettyEndTime: {
                        type: "string",
                        title: "Completed",
                        template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{completedDateString}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    prettyDurationInMillis: {
                        type: "string",
                        title: "Duration",
                        template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                        sortable: true,
                        columnSearch: false
                    },
                    priority: {
                        type: "string",
                        title: "Priority",
                        sortable: true,
                        columnSearch: false
                    },
                    prettyWorkTimeInMillis: {
                        type: "string",
                        title: "Work time",
                        template: '<div class="dateTemplate"><u>{{prettyWorkTimeInMillis}}</u><div>{{workTimeInMillis}}</div></div>',
                        sortable: false,
                        columnSearch: false
                    } 
                };
            }
            if (
                self.processList[key].selectedVariables != null &&
                self.processList[key].selectedVariables.length > 0
            ) {
                var selectedVars = self.processList[key].selectedVariables;
                for (var i = 0; i < selectedVars.length; i++) {
                    prop["a" + selectedVars[i]] = {
                        type: "string",
                        title: selectedVars[i],
                        sortable: false,
                        columnSearch: false
                    };
                }
            }

            return prop;
        },
        initProcessesTable(key) {
            let self = this;
            // Only create the table if it doesn't exist
            if (this.tableObj[key] == null) {
                const defName = this.processList[key].defName;
                let tableRef = this.$refs['myTable_' + defName];
                if (Array.isArray(tableRef)) {
                    tableRef = tableRef[0];
                }
                if (!tableRef) {
                    // Ref not ready, skip table creation for now
                    return;
                }
                self.updateCallTable = false;
                if (self.currentPageSize[key] == null) {
                    self.currentPageSize[key] = 10;
                }
                var propertyArray = [];

                this.tableObj[key] = window.tableFactory.create(tableRef, {
                    bordered: true,
                    striped: true,
                    emptyTemplate: '<p class="text-center m-0">No tasks found</p>',
                    loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                    columnSearch: false,
                    pageSize: self.currentPageSize[key],
                    debounceTime: 1000,
                    schema: {
                        properties: self.getDataTableProperties(key)
                    },
                    data: (
                        start,
                        limit,
                        sortHeader,
                        sortDirection,
                        fullTextQuery,
                        searchColumns
                    ) => {
                        if (!self.filterActive) {
                            self.updateCallTable = false;
                            if (self.tableObj[key] != null) {
                                self.currentPageSize[key] =
                                    self.tableObj[key].tableContext.store.state.pageSize;
                            }
                            var sortHeaderData = sortHeader == null ? "" : sortHeader;
                            var sortDir = sortDirection == null ? "" : sortDirection;
                            if (sortHeaderData == "prettyStartTime") {
                                sortHeaderData = "startTime";
                            } else if (sortHeaderData == "prettyEndTime") {
                                sortHeaderData = "endTime";
                            } else if (sortHeaderData == "prettyDurationInMillis") {
                                sortHeaderData = "duration";
                            } else if (sortHeaderData == "prettyDueDate") {
                                sortHeaderData = "dueDate";
                            } else if (sortHeaderData == "prettyCreateTime") {
                                sortHeaderData = "createTime";
                            }
                            var queryString =
                                "start=" +
                                start +
                                "&length=" +
                                self.currentPageSize[key] +
                                "&sort=" +
                                sortHeaderData +
                                "&dir=" +
                                sortDir +
                                "&processDefinitionName=" +
                                self.processList[key].defName +
                                "&filterInput=true&involvingAll=" +
                                self.involvingAll;
                            if (self.taskName != "") {
                                queryString += "&taskName=" + self.taskName;
                            }
                            if (self.taskId && self.taskId.trim() !== "") {
                                queryString += "&taskId=" + self.taskId;
                            }
                            if (self.startedAfter != "") {
                                queryString +=
                                    "&taskCreatedAfter=" +
                                    self.startedAfter +
                                    "&taskCreatedBefore=" +
                                    this.startedBefore;
                            }
                            if (self.finishedAfter != "") {
                                queryString +=
                                    "&taskCompletedAfter=" +
                                    self.finishedAfter +
                                    "&taskCompletedBefore=" +
                                    self.finishedBefore;
                            }
                            if (self.statusType == "open") {
                                queryString = queryString + "&finished=false";
                            } else if (self.statusType == "completed") {
                                queryString = queryString + "&finished=true";
                            }
                            if (self.selectedInvolving != "") {
                                queryString += "&taskInvolvedUser=" + encodeURI(self.selectedInvolving);
                            }
                            if (self.priority.trim() != "") {
                                queryString += "&taskPriority=" + self.priority;
                            }
                            if (self.selectedOwner != "") {
                                queryString += "&taskOwner=" + encodeURI(self.selectedOwner);
                            }
                            if (self.selectedAssignee != "") {
                                queryString += "&taskAssignee=" + encodeURI(self.selectedAssignee);
                            }
                            if (self.assignedTasksList) {
                                queryString += "&currentUser=true";
                            }
                            // Fetch parent process data
                            return this.getTasksList(queryString, key).then(parentData => {
                                // If there are subprocesses, fetch and append their data
                                const expandedProcessName = self.processList[key].defName;
                                const subprocesses = [];
                                for (const itemKey in self.processList) {
                                    const process = self.processList[itemKey];
                                    if (process.parentProcName && process.parentProcName === expandedProcessName) {
                                        subprocesses.push(process);
                                    }
                                }
                                if (subprocesses.length > 0) {
                                    // Build subprocess promises
                                    const subprocessPromises = subprocesses.map(subprocess => {
                                        const subQueryString = "start=0&length=10&sort=&dir=&processDefinitionName=" + encodeURIComponent(subprocess.defName) + "&filterInput=true";
                                        return self.getTasksList(subQueryString, key).then(subData => {
                                            if (subData && subData.data) {
                                                subData.data.forEach(row => {
                                                    row.isSubprocess = true;
                                                    row.subprocessName = subprocess.defName;
                                                });
                                            }
                                            return subData;
                                        });
                                    });
                                    return Promise.all(subprocessPromises).then(results => {
                                        let combinedData = [];
                                        if (parentData && parentData.data) {
                                            combinedData = [...parentData.data];
                                        }
                                        results.forEach(subData => {
                                            if (subData && subData.data) {
                                                combinedData.push(...subData.data);
                                            }
                                        });
                                        return {
                                            totalCount: combinedData.length,
                                            data: combinedData
                                        };
                                    });
                                } else {
                                    return parentData;
                                }
                            });
                        } else {
                            self.filterActive = false;
                            let responseData = {
                                totalCount: self.filterData.length,
                                data: self.filterData
                            };
                            return responseData;
                        }
                    },
                    onAfterDataLoad: (start, limit) => {
                        self.updateTemplate(key);
                    }
                });
            }
        },
        updateTemplate(key) {
            let self = this;
            const defName = this.processList[key].defName;
            let tableRef = this.$refs['myTable_' + defName];
            if (Array.isArray(tableRef)) {
                tableRef = tableRef[0];
            }
            if (!tableRef) return;
            // Wait for DOM to be ready (in case table is not rendered yet)
            self.$nextTick(() => {
                const links = tableRef.querySelectorAll('td .name-link');
                links.forEach(btn => {
                    btn.removeEventListener('click', self._tableNameClickHandler);
                    btn.addEventListener('click', self._tableNameClickHandler = function(e) {
                        self.setFilterDataInLocalStorage();
                        var targetEle = e.target;
                        if (targetEle != null) {
                            var reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/tasks/viewtask/" + self.title.toLowerCase() + "/" + reference.trim()
                            );
                        }
                    });
                });
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_taskName",
                this.taskName
            );
            if (!this.unclaimedTasks) {
                localStorage.setItem(
                    "DataTables_" + window.location.pathname + "_statusType",
                    this.statusType
                );
                localStorage.setItem(
                    "DataTables_" + window.location.pathname + "_endDateRangeRef",
                    this.endDateRangeRef
                );
            }
            if (this.involvingAll) {
                localStorage.setItem(
                    "DataTables_" + window.location.pathname + "_selectedAssignee",
                    this.selectedAssignee
                );
            }
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_priority",
                this.priority
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedOwner",
                this.selectedOwner
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving",
                this.selectedInvolving
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef",
                this.startDateRangeRef
            );
            localStorage.setItem("auditListFilterCount", this.filterCount);
        },
        getTotalNumberOfProcesses(app) {
            return app.numberOfProcesses;
        }
    }
};
</script>

<style scoped>
.mc-card-deck .mc-card {
    height: 120px;
    margin-left: 0;
    margin-right: 0;
}

.mc-list-group mosaic-badge {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}

.mcc-list-group-li {
    border-bottom: 1px solid #666679;
}

.mcc-list-group {
    border-top: 1px solid #666679;
    border-left: 1px solid #666679;
    border-right: 1px solid #666679;
}
</style>
